import { SubmissionError } from 'redux-form';

import { fetch } from '../../utils/dataAccess';
import { retrieveError, retrieveLoading, retrieveSuccess } from './update';

export function categoryRetrieve(id) {
  return dispatch => {
    dispatch(retrieveLoading(true));

    return fetch(id)
      .then(response => response.json().then(retrieved => ({ retrieved })))
      .then(({ retrieved }) => {
        dispatch(retrieveLoading(false));
        // return result to allow the tree to be updated
        return dispatch(retrieveSuccess(retrieved));
      })
      .catch(e => {
        dispatch(retrieveLoading(false));
        dispatch(retrieveError(e.message));
      });
  };
}

export function error(error) {
  return { type: 'CATEGORY_STORE_TREE_ERROR', error };
}

export function loading(loading) {
  return { type: 'CATEGORY_STORE_TREE_LOADING', loading };
}

export function success(stored) {
  if (stored && stored['@id']) {
    return {
      type: 'CATEGORY_UPDATE_UPDATE_SUCCESS',
      updated: stored,
      retrieved: stored
    };
  }
  return { type: 'CATEGORY_STORE_TREE_SUCCESS', stored };
}

export function categoryStoreTree(values) {
  return dispatch => {
    dispatch(loading(true));

    return fetch('/categories/store_tree', {
      method: 'POST',
      body: JSON.stringify(values)
    })
      .then(response => {
        dispatch(loading(false));

        return response.json();
      })
      .then(retrieved => dispatch(success(retrieved)))
      .catch(e => {
        dispatch(loading(false));

        if (e instanceof SubmissionError) {
          dispatch(error(e.errors._error));
          throw e;
        }

        dispatch(error(e.message));
      });
  };
}

export function reset() {
  return dispatch => {
    dispatch(loading(false));
    dispatch(error(null));
  };
}
